<template>
  <!-- 스크롤 안됨 -->
  <modal name="header-menu-modal" class="header-menu-modal"
         :width="'67.32%'"
         :height="'100%'"
         :transition="`modal-right`"
         @before-close="handlerBeforeClose"
         @before-open="handlerBeforeOpen"
         @opened="handlerOpened"
  >
    <div>
      <div class="header-menu-modal_wrap">
        <div class="header-menu-modal">
          <div class="header-menu-modal_head">
            <div class="header-menu-modal_head_home" @click="movePage($router.push('/'))"></div>
            <span class="header-menu-modal_head_search" @click="movePage('/search')"></span>
            <span class="header-menu-modal_head_close" @click="backEvent()"></span>
          </div>
          <div class="header-menu-modal_menu_papa" @click="movePage('/intro?tab=vision')" :class="{active:showPapa}">
            <div @click="showPapa = !showPapa">
              <div class="header-menu-modal_menu_papa_img"></div>
              <div class="header-menu-modal_menu_papa_title" @click="movePage('/intro?tab=vision')">함께하는아버지들?</div>
<!--              <div class="header-menu-modal_menu_papa_arrow"></div>-->
            </div>
<!--            <div class="header-menu-modal_menu_papa_sub">-->
<!--              <div class="header-menu-modal_menu_papa_menu" @click="movePage('/intro?tab=vision')">비전</div>-->
<!--              <div class="header-menu-modal_menu_papa_menu" @click="movePage('/intro?tab=business')">주요사업</div>-->
<!--              <div class="header-menu-modal_menu_papa_menu" @click="movePage('/intro?tab=info')">발자취</div>-->
<!--              <div class="header-menu-modal_menu_papa_menu" @click="movePage('/intro?tab=financial')">재무보고</div>-->
<!--              <div class="header-menu-modal_menu_papa_menu" @click="movePage('/intro?tab=donation')">후원안내</div>-->
<!--            </div>-->
          </div>
          <div class="header-menu-modal_menu_news" @click="movePage('/news')">
            <div class="header-menu-modal_menu_news_img"></div>
            <div class="header-menu-modal_menu_mews_title">뉴스</div>
          </div>
          <div class="header-menu-modal_menu_donate" @click="movePage('/donate')">
            <div class="header-menu-modal_menu_donate_img"></div>
            <div class="header-menu-modal_menu_donate_title">나눔&배움</div>
          </div>
          <div class="header-menu-modal_menu_amidan" @click="movePage('/amidan?tab=introduce')" :class="{active:showAmidan}">
            <div @click="showAmidan = !showAmidan">
              <div class="header-menu-modal_menu_amidan_img"></div>
              <div class="header-menu-modal_menu_amidan_title" @click="movePage('/amidan?tab=introduce')">아미단</div>
<!--              <div class="header-menu-modal_menu_amidan_arrow"></div>-->
            </div>
<!--            <div class="header-menu-modal_menu_amidan_sub">-->
<!--              <div class="header-menu-modal_menu_amidan_menu" @click="movePage('/amidan?tab=introduce')">아미단소개</div>-->
<!--              <div class="header-menu-modal_menu_amidan_menu" @click="movePage('/amidan?tab=mentor')">멘토소개</div>-->
<!--              <div class="header-menu-modal_menu_amidan_menu" @click="movePage('/amidan?tab=join')">가입신청</div>-->
<!--            </div>-->
          </div>
          <div class="header-menu-modal_menu_album" @click="movePage('/album')">
            <div class="header-menu-modal_menu_album_img"></div>
            <div class="header-menu-modal_menu_album_title">앨범</div>
          </div>
          <div class="header-menu-modal_sns">
            <div class="header-menu-modal_sns_box">
<!--              <div class="header-menu-modal_sns_box_papa"></div>-->
              <web-link-list-component></web-link-list-component>
            </div>
          </div>
          <button class="header_menu_modal_donateBtn" @click="moveDonate()">후원하기</button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import EventBus from "@/utils/event-bus";
import WebLinkListComponent from "@/components/weblink/WebLinkListComponent";

export default {
  name: "HeaderMenuModal",
  mixins: [],
  components: {WebLinkListComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      showPapa: false,
      showAmidan: false,
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
      moveDonate(){
          window.open('https://online.mrm.or.kr/RTsnoLd')
      },
    handlerBeforeOpen(event) {
      this.scroll = event.params.scroll
      document.body.classList.add('modal_open')
      document.body.style.top = `-${this.scroll}px`
    },
    handlerOpened() {
      EventBus.$emit('pushBackFunc', this.backEvent);
      // document.body.style.overflow = 'hidden'
    },
    handlerBeforeClose() {
      EventBus.$emit('popBackFunc');
      document.body.classList.remove('modal_open')
      document.body.style.removeProperty('top');

      window.scrollTo(0,this.scroll);
     // document.body.style.overflow = 'auto';
    },
    backEvent() {
      this.$modal.hide('header-menu-modal');
    },
    movePage(path) {
      if (this.$route.path === path) {
        return;
      }
      this.$modal.hide('header-menu-modal');
      this.$router.push(path);
    },

  },
  watch: {},
}
</script>

<style scoped>

</style>